import { Server as ServerV3_0 } from '@criteria/openapi/v3.0'
import { Server as ServerV3_1 } from '@criteria/openapi/v3.1'
import {
  Alert,
  AlertActions,
  AlertDescription,
  AlertTitle,
  Button,
  Subheading,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  Text
} from '@criteria-labs/react'
import { PlusCircleIcon, XMarkIcon } from '@heroicons/react/16/solid'
import { useState } from 'react'
import { Section } from '../Section'
import { RemoveServer } from '../changes/server'
import { useRouter } from '../router'
import { useDispatchChange } from '../useDispatchChange'

export function BaseURLsSection({ servers }: { servers: (ServerV3_0 | ServerV3_1)[] }) {
  const dispatchChange = useDispatchChange()
  const [deletingServerIndex, setDeletingServerIndex] = useState<number | null>(null)
  const { push } = useRouter()
  return (
    <Section>
      <div className="mb-3 mt-6 flex items-center justify-start gap-x-1">
        <Subheading>Base URLs</Subheading>
        <Button plain onClick={() => push('/new-base-url')}>
          <PlusCircleIcon />
        </Button>
      </div>
      {Object.entries(servers).length === 0 && <Text>No Base URLs.</Text>}
      {Object.entries(servers).length > 0 && (
        <Table dense bleed className="[--gutter:0]">
          <TableHead>
            <TableRow>
              <TableHeader>URL</TableHeader>
              <TableHeader className="relative w-0">
                <span className="sr-only">Actions</span>
              </TableHeader>
            </TableRow>
          </TableHead>
          <TableBody>
            {servers.map((server, index) => (
              <TableRow key={server.url} href="#">
                <TableCell>{server.url}</TableCell>
                <TableCell>
                  <Button plain aria-label="Delete endpoint" onClick={() => setDeletingServerIndex(index)}>
                    <XMarkIcon />
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
      <Alert open={deletingServerIndex !== null} onClose={() => setDeletingServerIndex(null)}>
        <AlertTitle>Delete Server?</AlertTitle>
        {typeof deletingServerIndex === 'number' && (
          <>
            <AlertDescription>
              <p>The base URL {servers[deletingServerIndex].url} will be deleted</p>
            </AlertDescription>
            <AlertActions>
              <Button plain onClick={() => setDeletingServerIndex(null)}>
                Cancel
              </Button>
              <Button
                onClick={() => {
                  dispatchChange(new RemoveServer(deletingServerIndex, true))
                  setDeletingServerIndex(null)
                }}
              >
                Delete
              </Button>
            </AlertActions>
          </>
        )}
      </Alert>
    </Section>
  )
}
